/* Attributes */
export const TEN_YEARS_IN_BUSINESS = '10+ Years in Business';
export const ALL_NATURAL_INGREDIENTS = 'All Natural Ingredients';
export const BIPOC_OWNED = 'BIPOC Owned';
export const FDA_APPROVED = 'FDA Approved';
export const FEMALE_OWNED = 'Female Owned';
export const FINE_JEWELRY = 'Fine Jewelry';
export const LOW_MOQS = 'Low MOQs';
export const CERTIFIED_ORGANIC = 'Certified Organic';
export const PACKAGING_OPTIONS = 'Packaging Options Available';
export const SUSTAINABLE_MATERIALS = 'Sustainable Materials';
export const USA_BASED = 'USA Based';
export const VEGAN = 'Vegan';
export const PRIVATE_LABEL = 'Private Label Products';
export const CONTRACT_MANUFACTURER = 'Contract Manufacturer';
export const TWO_DAY_PRODUCTION_TIMES = '48 Hour Production Times';
export const CAPACITY_FOR_25K_UNITS = 'Capacity for 25k+ Units';

/* Services Attributes */
export const FIVE_YEARS_EXPERIENCE = '5 Years Experience';
export const TEN_YEARS_EXPERIENCE = '10 Years Experience';
export const GRAPHIC_DESIGN = 'Graphic Design';
export const ILLUSTRATION = 'Illustration';
export const BRANDING = 'Branding';
export const WEB_DESIGN = 'Web Design';
export const PHOTOGRAPHY = 'Photography';
export const FASHION_DESIGN = 'Fashion Design (Tech Packs)';
export const AD_CREATIVE = 'Ad Creative';
export const CONSULTING = 'Consulting';
export const EDUCATIONAL_WORKSHOPS = 'Educational Workshops';

/* Color Palette */
export const ATTRIBUTE_PALETTE = {
  [TEN_YEARS_IN_BUSINESS]: '#FAEAE6',
  [ALL_NATURAL_INGREDIENTS]: '#ECECFD',
  [BIPOC_OWNED]: '#FFCCB6',
  [FDA_APPROVED]: '#FAF9E6',
  [FEMALE_OWNED]: '#FDE9E5',
  [FINE_JEWELRY]: '#FED7C3',
  [LOW_MOQS]: '#FF968A',
  [CERTIFIED_ORGANIC]: '#DEF3FD',
  [PACKAGING_OPTIONS]: '#FFD8BE',
  [SUSTAINABLE_MATERIALS]: '#FFC8A2',
  [VEGAN]: '#B6CFB6',
  [PRIVATE_LABEL]: '#ECEAE4',
  [CONTRACT_MANUFACTURER]: '#FFAEA5',
  [TWO_DAY_PRODUCTION_TIMES]: '#FAEAE6',
  [CAPACITY_FOR_25K_UNITS]: '#FED7C3',
  [FIVE_YEARS_EXPERIENCE]: '#FAEAE6',
  [TEN_YEARS_EXPERIENCE]: '#ECECFD',
  [GRAPHIC_DESIGN]: '#FFCCB6',
  [ILLUSTRATION]: '#FAF9E6',
  [BRANDING]: '#FDE9E5',
  [WEB_DESIGN]: '#FED7C3',
  [PHOTOGRAPHY]: '#FF968A',
  [FASHION_DESIGN]: '#DEF3FD',
  [AD_CREATIVE]: '#FFD8BE',
  [CONSULTING]: '#FFC8A2',
  [EDUCATIONAL_WORKSHOPS]: '#D4F0F0',
};

export const DEFAULT_PASTEL_SHADE = '#ECEAE4';
